(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novyra-harness-interactive"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('novyra-harness-interactive')) {
customElements.define('novyra-harness-interactive',class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.photo=this.querySelector('.nvp-main-image');
  this.addEventListener('change',e=>{if(e.target.matches('.nvp-colour input'))this.updatePhoto();this.update();});
  this.addEventListener('input',e=>{if(e.target.matches('.nvp-quantity input'))this.update();});
  this.querySelectorAll('[data-duo-select]').forEach(button=>button.addEventListener('click',()=>{
   const colour=this.querySelector('.nvp-colour input[value="'+button.dataset.duoSelect+'"]');
   if(!colour)return;colour.checked=true;colour.dispatchEvent(new Event('change',{bubbles:true}));
  }));
  this.querySelectorAll('[data-poster-size]').forEach(button=>button.addEventListener('click',()=>{
   const size=this.querySelector('.nvp-sizes input[value="'+button.dataset.posterSize+'"]');
   if(size){size.checked=true;size.dispatchEvent(new Event('change',{bubbles:true}));}
  }));

  this.update();this.updatePhoto();
 }
 clamp(value){return Math.min(999,Math.max(1,Math.floor(Number(value)||1)));}
 update(){
  const size=this.querySelector('.nvp-sizes input:checked'),input=this.querySelector('.nvp-quantity input');
  this.querySelectorAll('[data-poster-size]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.posterSize===size.value)));
  this.quantity=this.clamp(input.value);
  if(input.value&&Number(input.value)!==this.quantity)input.value=this.quantity;
  const dimensions={S:'40 × 30 × 12.5 cm',M:'50 × 35 × 13.5 cm',L:'65 × 45 × 16 cm',XL:'80 × 55 × 18 cm',XXL:'96 × 65 × 20 cm'};
  const target=this.querySelector('[data-dimensions]');
  if(target)target.textContent=this.dataset.locale.startsWith('fr')?dimensions[size.value].replace('.',','):dimensions[size.value];
  this.querySelectorAll('tbody tr').forEach(row=>row.classList.toggle('is-selected',row.querySelector('th').textContent===size.value));
  this.querySelector('novyra-market-prices')?.refresh?.();
 }
 updatePhoto(){
  const colour=this.querySelector('.nvp-colour input:checked');
  this.querySelector('[data-colour-name]').textContent=colour.dataset.label;
  this.querySelector('[data-photo-colour]').textContent=colour.dataset.label;
  const src=colour.dataset.image||(colour.value===this.dataset.initial?this.dataset.scene:'');
  this.querySelector('.nvp-missing').hidden=Boolean(src);
  if(this.photo){this.photo.hidden=!src;if(src){this.photo.src=src;this.photo.removeAttribute('srcset');this.photo.alt=this.dataset.title+' — '+colour.dataset.label;}}
  const chosen=this.querySelector('[data-duo-select="'+colour.value+'"]');
  const duo=this.querySelector('.nhi-duo-image');
  if(chosen&&duo){
   const source=chosen.dataset.duoSrc,frame=this.querySelector('[data-duo-zoom]'),add=this.querySelector('[data-demo]');
   if(duo.dataset.activeSource!==source){
    duo.dataset.activeSource=source;duo.style.opacity='0';frame.setAttribute('aria-busy','true');add.disabled=true;
    const reveal=()=>{if(duo.dataset.activeSource!==source)return;duo.style.opacity='1';frame.setAttribute('aria-busy','false');this.querySelector('novyra-market-prices')?.refresh?.();};
    duo.onload=reveal;duo.onerror=()=>{if(duo.dataset.activeSource===source){duo.style.opacity='1';frame.setAttribute('aria-busy','false');this.querySelector('novyra-market-prices')?.refresh?.();}};
    duo.removeAttribute('srcset');duo.src=source;if(duo.complete&&duo.naturalWidth)reveal();
   }
   const posterZoom=this.querySelector('[data-poster-zoom]');if(posterZoom)posterZoom.href=chosen.dataset.duoFull;
   duo.alt=this.dataset.duoAlt+' — '+colour.dataset.label;frame.href=chosen.dataset.duoFull;this.querySelector('[data-duo-colour]').textContent=colour.dataset.label;
  }
  this.querySelectorAll('[data-duo-select]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.duoSelect===colour.value)));
  const story=this.querySelector('.nvp-story img');
  if(story&&src){story.src=colour.dataset.story||src;story.removeAttribute('srcset');story.alt=(this.dataset.kind==='bed'?this.dataset.sleepAlt:this.dataset.title)+' — '+colour.dataset.label;}
 }

});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novyra-product-preview"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('novyra-product-preview')) {
customElements.define('novyra-product-preview',class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.photo=this.querySelector('.nvp-main-image');
  this.addEventListener('change',e=>{if(e.target.matches('.nvp-colour input'))this.updatePhoto();this.update();});
  this.addEventListener('input',e=>{if(e.target.matches('.nvp-quantity input'))this.update();});

  this.update();this.updatePhoto();
 }
 clamp(value){return Math.min(999,Math.max(1,Math.floor(Number(value)||1)));}
 update(){
  const size=this.querySelector('.nvp-sizes input:checked'),input=this.querySelector('.nvp-quantity input');
  this.quantity=this.clamp(input.value);
  if(input.value&&Number(input.value)!==this.quantity)input.value=this.quantity;
  const dimensions={S:'40 × 30 × 12.5 cm',M:'50 × 35 × 13.5 cm',L:'65 × 45 × 16 cm',XL:'80 × 55 × 18 cm',XXL:'96 × 65 × 20 cm'};
  const target=this.querySelector('[data-dimensions]');
  if(target)target.textContent=this.dataset.locale.startsWith('fr')?dimensions[size.value].replace('.',','):dimensions[size.value];
  this.querySelectorAll('tbody tr').forEach(row=>row.classList.toggle('is-selected',row.querySelector('th').textContent===size.value));
  this.querySelector('novyra-market-prices')?.refresh?.();
 }
 updatePhoto(){
  const colour=this.querySelector('.nvp-colour input:checked');
  this.querySelector('[data-colour-name]').textContent=colour.dataset.label;
  this.querySelector('[data-photo-colour]').textContent=colour.dataset.label;
  const src=colour.dataset.image||(colour.value===this.dataset.initial?this.dataset.scene:'');
  this.querySelector('.nvp-missing').hidden=Boolean(src);
  if(this.photo){this.photo.hidden=!src;if(src){this.photo.src=src;this.photo.removeAttribute('srcset');this.photo.alt=this.dataset.title+' — '+colour.dataset.label;}}
  const story=this.querySelector('.nvp-story img');
  if(story&&src){story.src=colour.dataset.story||src;story.removeAttribute('srcset');story.alt=(this.dataset.kind==='bed'?this.dataset.sleepAlt:this.dataset.title)+' — '+colour.dataset.label;}
 }

});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novyra-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('novyra-variant-controller')) {
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-nv-offer]')) return;
    const root = event.target.closest('.novyra-product');
    const form = event.target.closest('form');
    const variantId = form.querySelector('[data-nv-variant-id]');
    variantId.value = event.target.value;
    variantId.dispatchEvent(new Event('change', { bubbles: true }));
    root.querySelector('[data-nv-price]').textContent = event.target.dataset.price;
    const available = event.target.dataset.available === 'true';
    const button = root.querySelector('.nv-cta');
    button.disabled = !available;
    root.querySelector('[data-nv-cta]').textContent = available ? button.dataset.addLabel : button.dataset.unavailableLabel;
  });
}

if(!customElements.get('novyra-glove-gallery')){
 customElements.define('novyra-glove-gallery',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.index=0;
   this.buttons=Array.from(this.querySelectorAll('[data-nvg-index]'));
   this.photo=this.querySelector('.nvg-main');
   this.buttons.forEach((button,index)=>button.addEventListener('click',()=>this.show(index)));
   this.querySelector('[data-nvg-prev]').addEventListener('click',()=>this.show(this.index-1));
   this.querySelector('[data-nvg-next]').addEventListener('click',()=>this.show(this.index+1));
   this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});
   const stage=this.querySelector('.nvg-stage');
   stage.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')this.startX=e.clientX;});
   stage.addEventListener('pointerup',e=>{if(e.pointerType==='touch'&&typeof this.startX==='number'){const delta=e.clientX-this.startX;if(Math.abs(delta)>45)this.show(this.index+(delta<0?1:-1));this.startX=null;}});
  }
  show(index){this.index=(index+this.buttons.length)%this.buttons.length;const button=this.buttons[this.index];this.photo.removeAttribute('srcset');this.photo.src=button.dataset.nvgSrc;this.photo.alt=button.dataset.nvgAlt;this.querySelector('[data-nvg-photo-link]').href=button.dataset.nvgSrc;this.querySelector('[data-nvg-caption]').textContent=button.dataset.nvgAlt;this.querySelector('[data-nvg-count]').textContent=(this.index+1)+' / '+this.buttons.length;this.buttons.forEach((item,i)=>item.setAttribute('aria-current',String(i===this.index)));}
 });
}
if(!customElements.get('novyra-glove-story')){
 customElements.define('novyra-glove-story',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const dialog=this.querySelector('dialog'),large=this.querySelector('[data-nvg-large]'),scroller=this.querySelector('.nvg-lightbox-scroll'),toggle=this.querySelector('[data-nvg-zoom-toggle]');
   this.querySelectorAll('[data-nvg-zoom]').forEach(button=>button.addEventListener('click',()=>{
    large.src=button.dataset.nvgZoom;large.alt=button.dataset.nvgTitle;
    this.querySelector('[data-nvg-dialog-title]').textContent=button.dataset.nvgTitle;
    const detail=matchMedia('(max-width:700px)').matches;
    dialog.classList.toggle('is-detail',detail);toggle.setAttribute('aria-pressed',String(detail));dialog.showModal();scroller.scrollTop=0;scroller.scrollLeft=0;
   }));
   this.querySelector('[data-nvg-close]').addEventListener('click',()=>dialog.close());
   toggle.addEventListener('click',()=>{const detail=dialog.classList.toggle('is-detail');toggle.setAttribute('aria-pressed',String(detail));});
   dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  }
 });
}


  } catch(e) { console.error(e); }
})();
})();
